import { FC } from "react";
import { Heading, Icon, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, StackProps, Text, VStack } from "@chakra-ui/react";
import { Cell, Label, Pie, PieChart } from "recharts";
import { Shimmer } from "@am-tax/fe-core";
import { IconInfoCircle } from "@tabler/icons-react";

const CHART_SIZE = 160;
const INNER_RADIUS = 48;
const OUTER_RADIUS = 72;

export const PercentPie: FC<
    {
        title: string;
        subtitle?: string;
        description?: any;
        color?: string;
        targetName?: string;
        otherName?: string;
        isLoading: boolean;
        target: number | undefined;
        total: number | undefined;
    } & StackProps
> = ({ title, subtitle, description, color, targetName, otherName, isLoading, target, total, ...stackProps }) => {
    const other = total && target ? total - target : 0;

    return (
        <VStack {...stackProps}>
            <Heading variant={"info"} fontSize={"md"}>
                {title}&nbsp;
                {!subtitle && !description ? (
                    <></>
                ) : (
                    <Popover closeOnBlur closeOnEsc trigger="hover" placement="top" gutter={0}>
                        <PopoverTrigger>{<Icon boxSize="1.5em" verticalAlign="middle" as={IconInfoCircle} style={{ cursor: "pointer" }} />}</PopoverTrigger>
                        <PopoverContent w="400pt">
                            <PopoverArrow />
                            <PopoverBody p={"1rem"}>
                                <VStack spacing={".75rem"} textAlign={"center"}>
                                    <Text as="h1" textAlign={"center"} fontWeight={"bold"} fontSize={"lg"} color={"blackAlpha.800"}>
                                        {title}
                                    </Text>
                                    {!subtitle ? (
                                        <></>
                                    ) : (
                                        <Text as="h2" textAlign={"center"}>
                                            {subtitle}
                                        </Text>
                                    )}
                                    {!description ? (
                                        <></>
                                    ) : (
                                        <label style={{ textTransform: "none" }} color={"blackAlpha.800"}>
                                            {description}
                                        </label>
                                    )}
                                </VStack>
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                )}
            </Heading>
            <Shimmer isLoading={isLoading} boxSize={CHART_SIZE} borderRadius={"full"}>
                <PieChart width={CHART_SIZE} height={CHART_SIZE}>
                    <Pie
                        data={[
                            { name: targetName || "", value: target },
                            {
                                name: otherName || "",
                                value: other || (target ? 0 : 1),
                            },
                        ]}
                        cx={CHART_SIZE / 2 - 5}
                        cy={CHART_SIZE / 2 - 5}
                        innerRadius={INNER_RADIUS}
                        outerRadius={OUTER_RADIUS}
                        dataKey="value"
                    >
                        <Cell fill={color || "var(--chakra-colors-purple-400)"} />
                        <Cell fill={"var(--chakra-colors-gray-100)"} />
                        {total && target && (
                            <Label value={`${total ? Math.round((100 * target) / total) : 0}%`} position="center" style={{ fontSize: "1.5rem" }} />
                        )}
                    </Pie>
                </PieChart>
            </Shimmer>
            {!isLoading && total !== undefined && target !== undefined && (
                <Text fontSize="xs" color="gray.500" mt={-1}>
                    {target} of {total}
                </Text>
            )}
        </VStack>
    );
};
